import React, { useEffect, useState } from "react";
import { FiArrowRight, FiImage } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import styles from "../../styles/pages/Product/ProductCard.module.css";
import { Product } from "../../interfaces/products/product";

interface ProductCardProps {
  product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const navigate = useNavigate();
  const image = product.images?.[0];
  const imageCount = product.images?.length || 0;
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [image]);

  const openDetails = () => navigate(`/product/${product.slug}`);

  return (
    <article className={styles.card}>
      <div className={styles.media}>
        <button
          type="button"
          className={styles.imageButton}
          onClick={openDetails}
          aria-label={`Open ${product.title}`}
        >
          {image && !imageFailed ? (
            <img
              src={image}
              alt={product.title}
              loading="lazy"
              onError={() => setImageFailed(true)}
            />
          ) : (
            <div className={styles.imageFallback}>
              <FiImage />
              <span>Product image unavailable</span>
            </div>
          )}
        </button>

        {imageCount > 1 && (
          <span className={styles.imageCount}>
            <FiImage /> {imageCount} images
          </span>
        )}
      </div>

      <div className={styles.badges}>
        {product.isDiwaliDeal && <span className={styles.diwali}>Diwali Deal</span>}
        {product.isTrending && <span className={styles.trending}>Trending</span>}
        {product.isFeatured && <span className={styles.featured}>Featured</span>}
      </div>

      <div className={styles.content}>
        <div className={styles.meta}>
          <span>{product.category || "Shopping pick"}</span>
          {product.subCategory && <span>• {product.subCategory}</span>}
        </div>

        <h3 className={styles.title} title={product.title}>
          {product.title}
        </h3>

        <p className={styles.description}>
          {product.description?.trim() || "Explore product details, images and marketplace information."}
        </p>

        <button type="button" className={styles.detailsButton} onClick={openDetails}>
          View product details
          <FiArrowRight />
        </button>
      </div>
    </article>
  );
};

export default ProductCard;
